import React from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';

const ControlRadioButton = ({index, label, hasDefault = true}) => {
  const name = `c${index}`;
  const labelId = `${name}-label`;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      border="1px solid #ccc"
      p="10px"
      borderRadius="8px"
      gap="12px">
      <FormControl size="small">
        <FormLabel size="small" id={labelId}>
          {label}
        </FormLabel>
        <RadioGroup aria-labelledby={labelId} defaultValue={hasDefault ? 1 : undefined} name={name}>
          <FormControlLabel value={1} control={<Radio />} label="Në rregull" />
          <Box display="flex" flewWrap="wrap">
            <FormControlLabel
              value={2}
              control={<Radio />}
              label="Kërkohet riparimi"
            />
            <FormControlLabel
              value={3}
              control={<Radio />}
              label="Riparuar/Ndërruar"
            />
          </Box>
        </RadioGroup>
      </FormControl>
      <TextField
        name={`${name}Comment`}
        multiline
        minRows={1}
        label="Komenti"
        fullWidth
        size="small"
      />
    </Box>
  );
};

export default ControlRadioButton;
